// extracted by mini-css-extract-plugin
module.exports = {"column":"style_column__ayf1X","emptyData":"style_emptyData__17FCd","Numerics":"style_Numerics__1gMsK"};